import { render, staticRenderFns } from "./router-view.vue?vue&type=template&id=0f212735&scoped=true&"
import script from "./router-view.vue?vue&type=script&lang=js&"
export * from "./router-view.vue?vue&type=script&lang=js&"
import style0 from "./router-view.vue?vue&type=style&index=0&id=0f212735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f212735",
  null
  
)

export default component.exports